<template>
  <div>
    <aha-dropdown-item
      class="present-now__wrapper"
      @click="$emit('handlePresentMenuClick', 'present-now')"
      v-if="!isNewPresentation"
    >
      <p class="mb-1 font-bold text-secondary-100">
        {{ $i18nPresenter.t('Present now') }} (Shift P)
      </p>
      <p class="text-xs text-base-80">
        {{ $i18nPresenter.t('Present from the current slide') }}
      </p>
    </aha-dropdown-item>
    <aha-dropdown-item
      class="present-now__wrapper"
      @click="$emit('handlePresentMenuClick', 'present-from-beginning')"
      v-if="!isNewPresentation"
    >
      <p class="mb-1 font-bold text-secondary-100">
        {{ $i18nPresenter.t('Present from beginning') }}
      </p>
      <p class="text-xs text-base-80">
        {{ $i18nPresenter.t('Present from the first slide') }}
      </p>
    </aha-dropdown-item>
    <aha-input-group
      class="flex items-center pt-3 pb-3 pl-4 rounded-b-lg"
    >
      <aha-checkbox
        v-model="currentUser.rememberSettings.fullscreen"
        @change="toggleFullscreenSetting"
        id="full-screen-check"
      >
        {{ $i18nPresenter.t('Full screen') }}
      </aha-checkbox>
    </aha-input-group>
  </div>
</template>

<script>
import EditorHeaderPresentButton from '@/components-v2/presentation-editor/editor-header/EditorHeaderPresentButton.vue'

export default {
  extends: EditorHeaderPresentButton,
}
</script>

<style lang="scss" scoped>
.present-now__wrapper {
  @apply h-auto pt-4 pb-3 border-b rounded-t-lg border-base-30 px-4;
}
.backstage__badge {
  @apply bg-yellow-50 ml-1;
}
</style>
